import script from "./DocsExampleMD.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsExampleMD.vue?vue&type=script&setup=true&lang=js"

import "./DocsExampleMD.vue?vue&type=style&index=0&id=29af9cb8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29af9cb8"]])

export default __exports__